import type { LoyaltyTierPrize } from "kadow-jetpack-model";
import { tt } from "../../../../../utils/i18n/i18n";
import type ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import type SubscriptionPlanDTO from "@tootsweet/model/datatransfer/SubscriptionPlanDTO";
import TSUtils from "../../../../../utils/helpers/TSUtils";

export function buildDefaultTierPrize(
  _accountToDisplay?: ManagedAccount,
  _subscriptionPlans?: SubscriptionPlanDTO[]
): LoyaltyTierPrize {
  return {
    id: TSUtils.generateRandomString(5),
    name: tt("surprise_gift"),
    image: "🎁",
    description: "",
    expiry: { method: "none", value: 0 },
    unBlurDelay: 1,
    conditions: [],
    pc: 0,
    isVoucher: false
  };
}

export function isTierRewardTokens(
  reward: number | string | LoyaltyTierPrize
): reward is number {
  return typeof reward === "number";
}
